/*函数节流*/
export function throttle(fn, interval = 300) {  //应用于处理高频点击提交，表单重复提交
  let enterTime = 0;//触发的时间
  return function(...args){
    let backTime = new Date();//第一次函数return即触发的时间
    if (backTime - enterTime > interval) {
      fn.call(this, args);
      enterTime = backTime;//赋值给第一次触发的时间，这样就保存了第二次触发的时间
    }
  }
}

// 函数防抖动
export function debounce(func,delay=1000){
  let timer = null;
  return function(...args){
    clearTimeout(timer);
    timer = setTimeout(()=>{
      func.call(this,args)
    },delay)
  }
}

// 时间戳转时间格式
export function formatDate(date,fmt){
  date = new Date(date) //如果传来的是秒级时间戳就应用此函数转换
  if(/(y+)/.test(fmt)){
    fmt = fmt.replace(RegExp.$1,(date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+' : date.getMonth() + 1,
    'd+' : date.getDate(),
    'h+' : date.getHours(),
    'm+' : date.getMinutes(),
    's+' : date.getSeconds()
  }
  for (let k in o){
    if(new RegExp(`(${k})`).test(fmt)){
      let str= o[k] + '';
      fmt =fmt.replace(RegExp.$1,(RegExp.$1.length ===1 ?str:padLeftZero(str)))
    }
  }
  return fmt;
  function padLeftZero(str) {
    return ('00' + str).substr(str.length)
  }
}
